import React from 'react';
import { Wave } from '../components/Wave';
import { useSEO } from '../hooks/useSEO';
import { getPageSEO } from '../data/seoData';

export const About = () => {
  // SEO Configuration
  useSEO(getPageSEO('about'));

  return <div className="w-full">
      <section className="bg-gradient-to-b from-blue-800 via-blue-700 to-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">Sobre IPSE SA</h1>
          <p className="text-xl mb-8">
            Innovando y transformando el panorama tecnológico empresarial desde
            2019
          </p>
        </div>
      </section>
      <Wave color="#fff" className="bg-blue-600" pattern="pattern1" />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">Nuestra Misión</h2>
              <p className="text-gray-600 mb-4">
                En IPSE SA, estamos comprometidos con proporcionar soluciones de
                software innovadoras que ayuden a las empresas a prosperar en la
                era digital. Nuestra misión es simplificar los desafíos
                tecnológicos complejos y empoderar a las organizaciones para
                alcanzar su máximo potencial.
              </p>
              <p className="text-gray-600">
                Fundada en 2019, hemos ayudado a cientos de empresas a
                transformar sus operaciones a través de nuestras soluciones SaaS
                de vanguardia.
              </p>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3" alt="Colaboración en equipo" className="rounded-lg shadow-lg" />
            </div>
          </div>
        </div>
      </section>
    </div>;
};